import { create } from 'zustand'
import Database from './types/Database'

// Serialized version of Database.User with Firestore types replaced by plain JS types.
// Timestamps become Date, GeoPoint becomes { latitude, longitude }.
export interface SerializedAccreditation {
  type: 'padi' | 'ssi' | 'sdi' | 'naui' | 'raid'
  level?: string
  fullName: string
  dateOfBirth: Date
  certificationNumber: string
  optionalMemberId: string | null
  documentUrl: string
  status: 'pending' | 'verified' | 'rejected'
  submittedAt: Date
  reviewedAt: Date | null
  reviewedBy: string | null
  registeredEmail?: string // PADI only
}

export interface SerializedUser {
  id: string
  displayName: string
  email: string
  handle: string | null
  suburb: string | null
  location: { latitude: number; longitude: number } | null
  role: 'member' | 'admin'
  guidedDiveFlag: boolean
  profileComplete: boolean
  creditBalance: number
  accreditation: SerializedAccreditation | null
  bankDetails: Database.BankDetails | null
  allowlist: string[] | null
  perfectRatingCount: number | null
  ratingAggregates?: Database.RatingAggregates | null
  accountStatus: Database.AccountStatus
  createdAt: Date
  updatedAt: Date
}

interface SessionState {
  user: {
    uid: string
    email: string | null
    displayName: string | null
    photoURL: string | null
    emailVerified: boolean
    providerId: string
  } | null
  profile: SerializedUser | null
  isAuthenticating: boolean
  setSession: (session: Pick<SessionState, 'user' | 'isAuthenticating'>) => void
  setProfile: (profile: SerializedUser | null) => void
  clearSession: () => void
}

export const useSessionStore = create<SessionState>(set => ({
  user: null,
  profile: null,
  isAuthenticating: true,
  setSession: session => set(session),
  setProfile: profile => set({ profile }),
  clearSession: () =>
    set({ user: null, profile: null, isAuthenticating: false })
}))
